import type { RouteRecordRaw } from 'vue-router';

export const tableRoute: RouteRecordRaw = {
  path: '/adjectives/table',
  name: 'AdjectivesTable',
  component: () => import('./pages/AdjectivesTablePage.vue'),
  meta: { layout: 'main' },
};

export const comparativesRoute: RouteRecordRaw = {
  path: '/adjectives/comparatives',
  name: 'AdjectivesComparatives',
  component: () => import('./pages/ComparativesPage.vue'),
  meta: { layout: 'main' },
};

export const possessivesRoute: RouteRecordRaw = {
  path: '/adjectives/possessives',
  name: 'AdjectivesPossessives',
  component: () => import('./pages/PossessivesPage.vue'),
  meta: { layout: 'main' },
};
